var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackerHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_362",
    "data-name": "Group 362",
    transform: "translate(-1203 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(1203 861)",
    style: {
      stroke: "#000",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_142",
    d: "M5938.5-12001.75l16.5 15h-5.5v13.5h-7.5v-10.75h-7.5v10.75h-7.25v-13.5H5922z",
    "data-name": "Path 142",
    transform: "translate(-4693.5 12890.25)",
    style: {
      stroke: "#060606",
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerHome);
export default __webpack_public_path__ + "static/media/tracker-home.4342eb085e48148dd6ff87dd314f4e20.svg";
export { ForwardRef as ReactComponent };